import { createFileRoute } from '@tanstack/react-router';
import DistributorDashboardView from '../views/distributor-dashboard';

export const Route = createFileRoute('/distributor/')({
  component: DistributorDashboardView,
});
